"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/regeneratorRuntime"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defaultAppData = _interopRequireDefault(require("./defaultAppData"));
var _schema = _interopRequireDefault(require("default-app/dist/common/schema"));
var _excluded = ["props"],
  _excluded2 = ["props"],
  _excluded3 = ["props"],
  _excluded4 = ["props"],
  _excluded5 = ["props"],
  _excluded6 = ["props"];
function _default(_ref) {
  var data = _ref.data;
  var generateLabelForArrayItems = function generateLabelForArrayItems(_ref2) {
    var props = _ref2.props;
    var value = props.value,
      propertyKey = props.propertyKey;
    if (value && value.name && Object.keys(value.name)[0]) {
      var key = value.key || propertyKey;
      return value.name[Object.keys(value.name)[0]] + " [" + key + "]";
    }
    return propertyKey.slice ? propertyKey.slice(0, 1).toUpperCase() + propertyKey.slice(1) : propertyKey.toString();
  };
  var subscribePropertiesForLabelForArrayItems = function subscribePropertiesForLabelForArrayItems(_ref3) {
    var _rootData$settings, _rootData$settings$ba;
    var schemaFormContext = _ref3.schemaFormContext,
      props = _ref3.props,
      setLabel = _ref3.setLabel;
    var stateManager = schemaFormContext.stateManager,
      rootData = schemaFormContext.rootData;
    var propertyTreeString = props.propertyTreeString,
      value = props.value,
      propertyKey = props.propertyKey;
    var languages = ((_rootData$settings = rootData.settings) === null || _rootData$settings === void 0 ? void 0 : (_rootData$settings$ba = _rootData$settings.basic_settings) === null || _rootData$settings$ba === void 0 ? void 0 : _rootData$settings$ba.languages) || ["lang_1"];
    return stateManager.subscribe( /*#__PURE__*/function () {
      var _ref5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee(state, _ref4) {
        var type, payload, changingItemPropertyTreeString, key;
        return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              type = _ref4.type, payload = _ref4.payload;
              if (!(type === "SET_LABEL")) {
                _context.next = 7;
                break;
              }
              changingItemPropertyTreeString = payload.name;
              if (!(changingItemPropertyTreeString === propertyTreeString + ".name." + languages[0])) {
                _context.next = 7;
                break;
              }
              key = value.key || propertyKey;
              _context.next = 7;
              return setLabel(payload.value + " [" + key + "]");
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x, _x2) {
        return _ref5.apply(this, arguments);
      };
    }());
  };
  function updateEditor(_x3) {
    return _updateEditor.apply(this, arguments);
  }
  function _updateEditor() {
    _updateEditor = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee128(p) {
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee128$(_context128) {
        while (1) switch (_context128.prev = _context128.next) {
          case 0:
            _context128.next = 2;
            return p.schemaFormContext.props.additionalProperties.updateEditor(p);
          case 2:
          case "end":
            return _context128.stop();
        }
      }, _callee128);
    }));
    return _updateEditor.apply(this, arguments);
  }
  function getPostFilters() {
    return {
      schemaType: "Array",
      add: function () {
        var _add = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee2(_ref6) {
          var props, rest, setValue, _props$value, value;
          return (0, _regeneratorRuntime2["default"])().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                props = _ref6.props, rest = (0, _objectWithoutProperties2["default"])(_ref6, _excluded);
                setValue = props.setValue, _props$value = props.value, value = _props$value === void 0 ? [] : _props$value;
                value.push({
                  type: "grayscale",
                  value: 1
                });
                _context2.next = 5;
                return setValue(value, true);
              case 5:
                _context2.next = 7;
                return updateEditor((0, _objectSpread2["default"])({
                  props: props
                }, rest));
              case 7:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        function add(_x4) {
          return _add.apply(this, arguments);
        }
        return add;
      }(),
      items: {
        schemaType: "Object",
        generateLabel: generateLabelForArrayItems,
        useEffectForLabel: subscribePropertiesForLabelForArrayItems,
        onDelete: function () {
          var _onDelete = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee3(p) {
            return (0, _regeneratorRuntime2["default"])().wrap(function _callee3$(_context3) {
              while (1) switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return updateEditor(p);
                case 2:
                case "end":
                  return _context3.stop();
              }
            }, _callee3);
          }));
          function onDelete(_x5) {
            return _onDelete.apply(this, arguments);
          }
          return onDelete;
        }(),
        properties: {
          type: {
            schemaType: "String",
            onBlur: function () {
              var _onBlur = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee4(p) {
                return (0, _regeneratorRuntime2["default"])().wrap(function _callee4$(_context4) {
                  while (1) switch (_context4.prev = _context4.next) {
                    case 0:
                      _context4.next = 2;
                      return updateEditor(p);
                    case 2:
                    case "end":
                      return _context4.stop();
                  }
                }, _callee4);
              }));
              function onBlur(_x6) {
                return _onBlur.apply(this, arguments);
              }
              return onBlur;
            }()
          },
          value: {
            schemaType: "Number",
            onBlur: function () {
              var _onBlur2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee5(p) {
                return (0, _regeneratorRuntime2["default"])().wrap(function _callee5$(_context5) {
                  while (1) switch (_context5.prev = _context5.next) {
                    case 0:
                      _context5.next = 2;
                      return updateEditor(p);
                    case 2:
                    case "end":
                      return _context5.stop();
                  }
                }, _callee5);
              }));
              function onBlur(_x7) {
                return _onBlur2.apply(this, arguments);
              }
              return onBlur;
            }()
          }
        }
      }
    };
  }
  function getRendererDataForSplitScreen() {
    return {
      schemaType: "Object",
      properties: {
        visibility: {
          schemaType: "String",
          onBlur: function () {
            var _onBlur3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee6(p) {
              return (0, _regeneratorRuntime2["default"])().wrap(function _callee6$(_context6) {
                while (1) switch (_context6.prev = _context6.next) {
                  case 0:
                    _context6.next = 2;
                    return updateEditor(p);
                  case 2:
                  case "end":
                    return _context6.stop();
                }
              }, _callee6);
            }));
            function onBlur(_x8) {
              return _onBlur3.apply(this, arguments);
            }
            return onBlur;
          }()
        },
        width: {
          schemaType: "Number",
          onBlur: function () {
            var _onBlur4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee7(p) {
              return (0, _regeneratorRuntime2["default"])().wrap(function _callee7$(_context7) {
                while (1) switch (_context7.prev = _context7.next) {
                  case 0:
                    _context7.next = 2;
                    return updateEditor(p);
                  case 2:
                  case "end":
                    return _context7.stop();
                }
              }, _callee7);
            }));
            function onBlur(_x9) {
              return _onBlur4.apply(this, arguments);
            }
            return onBlur;
          }()
        },
        height: {
          schemaType: "Number",
          onBlur: function () {
            var _onBlur5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee8(p) {
              return (0, _regeneratorRuntime2["default"])().wrap(function _callee8$(_context8) {
                while (1) switch (_context8.prev = _context8.next) {
                  case 0:
                    _context8.next = 2;
                    return updateEditor(p);
                  case 2:
                  case "end":
                    return _context8.stop();
                }
              }, _callee8);
            }));
            function onBlur(_x10) {
              return _onBlur5.apply(this, arguments);
            }
            return onBlur;
          }()
        },
        left: {
          schemaType: "Number",
          onBlur: function () {
            var _onBlur6 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee9(p) {
              return (0, _regeneratorRuntime2["default"])().wrap(function _callee9$(_context9) {
                while (1) switch (_context9.prev = _context9.next) {
                  case 0:
                    _context9.next = 2;
                    return updateEditor(p);
                  case 2:
                  case "end":
                    return _context9.stop();
                }
              }, _callee9);
            }));
            function onBlur(_x11) {
              return _onBlur6.apply(this, arguments);
            }
            return onBlur;
          }()
        },
        top: {
          schemaType: "Number",
          onBlur: function () {
            var _onBlur7 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee10(p) {
              return (0, _regeneratorRuntime2["default"])().wrap(function _callee10$(_context10) {
                while (1) switch (_context10.prev = _context10.next) {
                  case 0:
                    _context10.next = 2;
                    return updateEditor(p);
                  case 2:
                  case "end":
                    return _context10.stop();
                }
              }, _callee10);
            }));
            function onBlur(_x12) {
              return _onBlur7.apply(this, arguments);
            }
            return onBlur;
          }()
        },
        editLines: {
          schemaType: "Object",
          properties: {
            show: {
              schemaType: "Boolean",
              onBlur: function () {
                var _onBlur8 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee11(p) {
                  return (0, _regeneratorRuntime2["default"])().wrap(function _callee11$(_context11) {
                    while (1) switch (_context11.prev = _context11.next) {
                      case 0:
                        _context11.next = 2;
                        return updateEditor(p);
                      case 2:
                      case "end":
                        return _context11.stop();
                    }
                  }, _callee11);
                }));
                function onBlur(_x13) {
                  return _onBlur8.apply(this, arguments);
                }
                return onBlur;
              }()
            }
          }
        },
        calloutNotations: {
          schemaType: "Object",
          properties: {
            show: {
              schemaType: "Boolean",
              onBlur: function () {
                var _onBlur9 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee12(p) {
                  return (0, _regeneratorRuntime2["default"])().wrap(function _callee12$(_context12) {
                    while (1) switch (_context12.prev = _context12.next) {
                      case 0:
                        _context12.next = 2;
                        return updateEditor(p);
                      case 2:
                      case "end":
                        return _context12.stop();
                    }
                  }, _callee12);
                }));
                function onBlur(_x14) {
                  return _onBlur9.apply(this, arguments);
                }
                return onBlur;
              }()
            }
          }
        },
        postFilters: getPostFilters()
      }
    };
  }
  function getCameraDataForObject() {
    return {
      schemaType: "Object",
      properties: {
        hidden: {
          schemaType: "Boolean",
          onBlur: function () {
            var _onBlur10 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee13(p) {
              return (0, _regeneratorRuntime2["default"])().wrap(function _callee13$(_context13) {
                while (1) switch (_context13.prev = _context13.next) {
                  case 0:
                    _context13.next = 2;
                    return updateEditor(p);
                  case 2:
                  case "end":
                    return _context13.stop();
                }
              }, _callee13);
            }));
            function onBlur(_x15) {
              return _onBlur10.apply(this, arguments);
            }
            return onBlur;
          }()
        }
      }
    };
  }
  return (0, _objectSpread2["default"])({}, (0, _schema["default"])({
    data: data,
    properties: {
      renderProps: {
        schemaType: "Object",
        properties: {
          renderType: {
            schemaType: "String",
            onBlur: function () {
              var _onBlur11 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee14(p) {
                return (0, _regeneratorRuntime2["default"])().wrap(function _callee14$(_context14) {
                  while (1) switch (_context14.prev = _context14.next) {
                    case 0:
                      _context14.next = 2;
                      return updateEditor(p);
                    case 2:
                    case "end":
                      return _context14.stop();
                  }
                }, _callee14);
              }));
              function onBlur(_x16) {
                return _onBlur11.apply(this, arguments);
              }
              return onBlur;
            }()
          },
          lineProps: {
            schemaType: "Object",
            properties: {
              opacity: {
                schemaType: "Number",
                onBlur: function () {
                  var _onBlur12 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee15(p) {
                    return (0, _regeneratorRuntime2["default"])().wrap(function _callee15$(_context15) {
                      while (1) switch (_context15.prev = _context15.next) {
                        case 0:
                          _context15.next = 2;
                          return updateEditor(p);
                        case 2:
                        case "end":
                          return _context15.stop();
                      }
                    }, _callee15);
                  }));
                  function onBlur(_x17) {
                    return _onBlur12.apply(this, arguments);
                  }
                  return onBlur;
                }()
              },
              color: {
                schemaType: "String",
                onBlur: function () {
                  var _onBlur13 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee16(p) {
                    return (0, _regeneratorRuntime2["default"])().wrap(function _callee16$(_context16) {
                      while (1) switch (_context16.prev = _context16.next) {
                        case 0:
                          _context16.next = 2;
                          return updateEditor(p);
                        case 2:
                        case "end":
                          return _context16.stop();
                      }
                    }, _callee16);
                  }));
                  function onBlur(_x18) {
                    return _onBlur13.apply(this, arguments);
                  }
                  return onBlur;
                }()
              },
              linewidth: {
                schemaType: "Number",
                onBlur: function () {
                  var _onBlur14 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee17(p) {
                    return (0, _regeneratorRuntime2["default"])().wrap(function _callee17$(_context17) {
                      while (1) switch (_context17.prev = _context17.next) {
                        case 0:
                          _context17.next = 2;
                          return updateEditor(p);
                        case 2:
                        case "end":
                          return _context17.stop();
                      }
                    }, _callee17);
                  }));
                  function onBlur(_x19) {
                    return _onBlur14.apply(this, arguments);
                  }
                  return onBlur;
                }()
              },
              disable: {
                schemaType: "Number",
                onBlur: function () {
                  var _onBlur15 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee18(p) {
                    return (0, _regeneratorRuntime2["default"])().wrap(function _callee18$(_context18) {
                      while (1) switch (_context18.prev = _context18.next) {
                        case 0:
                          _context18.next = 2;
                          return updateEditor(p);
                        case 2:
                        case "end":
                          return _context18.stop();
                      }
                    }, _callee18);
                  }));
                  function onBlur(_x20) {
                    return _onBlur15.apply(this, arguments);
                  }
                  return onBlur;
                }()
              }
            }
          },
          composer: {
            schemaType: "Object",
            properties: {
              enable: {
                schemaType: "Boolean",
                onBlur: function () {
                  var _onBlur16 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee19(p) {
                    return (0, _regeneratorRuntime2["default"])().wrap(function _callee19$(_context19) {
                      while (1) switch (_context19.prev = _context19.next) {
                        case 0:
                          _context19.next = 2;
                          return updateEditor(p);
                        case 2:
                        case "end":
                          return _context19.stop();
                      }
                    }, _callee19);
                  }));
                  function onBlur(_x21) {
                    return _onBlur16.apply(this, arguments);
                  }
                  return onBlur;
                }()
              },
              waterColor: {
                schemaType: "Object",
                onBlur: function () {
                  var _onBlur17 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee20(p) {
                    return (0, _regeneratorRuntime2["default"])().wrap(function _callee20$(_context20) {
                      while (1) switch (_context20.prev = _context20.next) {
                        case 0:
                          _context20.next = 2;
                          return updateEditor(p);
                        case 2:
                        case "end":
                          return _context20.stop();
                      }
                    }, _callee20);
                  }));
                  function onBlur(_x22) {
                    return _onBlur17.apply(this, arguments);
                  }
                  return onBlur;
                }(),
                properties: {
                  enable: {
                    schemaType: "Boolean",
                    onBlur: function () {
                      var _onBlur18 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee21(p) {
                        return (0, _regeneratorRuntime2["default"])().wrap(function _callee21$(_context21) {
                          while (1) switch (_context21.prev = _context21.next) {
                            case 0:
                              _context21.next = 2;
                              return updateEditor(p);
                            case 2:
                            case "end":
                              return _context21.stop();
                          }
                        }, _callee21);
                      }));
                      function onBlur(_x23) {
                        return _onBlur18.apply(this, arguments);
                      }
                      return onBlur;
                    }()
                  },
                  intensity: {
                    schemaType: "Number",
                    onBlur: function () {
                      var _onBlur19 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee22(p) {
                        return (0, _regeneratorRuntime2["default"])().wrap(function _callee22$(_context22) {
                          while (1) switch (_context22.prev = _context22.next) {
                            case 0:
                              _context22.next = 2;
                              return updateEditor(p);
                            case 2:
                            case "end":
                              return _context22.stop();
                          }
                        }, _callee22);
                      }));
                      function onBlur(_x24) {
                        return _onBlur19.apply(this, arguments);
                      }
                      return onBlur;
                    }()
                  }
                }
              },
              renderer: {
                schemaType: "Object",
                onBlur: function () {
                  var _onBlur20 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee23(p) {
                    return (0, _regeneratorRuntime2["default"])().wrap(function _callee23$(_context23) {
                      while (1) switch (_context23.prev = _context23.next) {
                        case 0:
                          _context23.next = 2;
                          return updateEditor(p);
                        case 2:
                        case "end":
                          return _context23.stop();
                      }
                    }, _callee23);
                  }));
                  function onBlur(_x25) {
                    return _onBlur20.apply(this, arguments);
                  }
                  return onBlur;
                }(),
                properties: {
                  opacity: {
                    schemaType: "Number",
                    onBlur: function () {
                      var _onBlur21 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee24(p) {
                        return (0, _regeneratorRuntime2["default"])().wrap(function _callee24$(_context24) {
                          while (1) switch (_context24.prev = _context24.next) {
                            case 0:
                              _context24.next = 2;
                              return updateEditor(p);
                            case 2:
                            case "end":
                              return _context24.stop();
                          }
                        }, _callee24);
                      }));
                      function onBlur(_x26) {
                        return _onBlur21.apply(this, arguments);
                      }
                      return onBlur;
                    }()
                  },
                  blendMode: {
                    schemaType: "String",
                    onBlur: function () {
                      var _onBlur22 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee25(p) {
                        return (0, _regeneratorRuntime2["default"])().wrap(function _callee25$(_context25) {
                          while (1) switch (_context25.prev = _context25.next) {
                            case 0:
                              _context25.next = 2;
                              return updateEditor(p);
                            case 2:
                            case "end":
                              return _context25.stop();
                          }
                        }, _callee25);
                      }));
                      function onBlur(_x27) {
                        return _onBlur22.apply(this, arguments);
                      }
                      return onBlur;
                    }()
                  }
                }
              }
            }
          },
          shadow: {
            schemaType: "Object",
            properties: {
              enable: {
                schemaType: "Boolean",
                onBlur: function () {
                  var _onBlur23 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee26(p) {
                    return (0, _regeneratorRuntime2["default"])().wrap(function _callee26$(_context26) {
                      while (1) switch (_context26.prev = _context26.next) {
                        case 0:
                          _context26.next = 2;
                          return updateEditor(p);
                        case 2:
                        case "end":
                          return _context26.stop();
                      }
                    }, _callee26);
                  }));
                  function onBlur(_x28) {
                    return _onBlur23.apply(this, arguments);
                  }
                  return onBlur;
                }()
              },
              opacity: {
                schemaType: "Number",
                onBlur: function () {
                  var _onBlur24 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee27(p) {
                    return (0, _regeneratorRuntime2["default"])().wrap(function _callee27$(_context27) {
                      while (1) switch (_context27.prev = _context27.next) {
                        case 0:
                          _context27.next = 2;
                          return updateEditor(p);
                        case 2:
                        case "end":
                          return _context27.stop();
                      }
                    }, _callee27);
                  }));
                  function onBlur(_x29) {
                    return _onBlur24.apply(this, arguments);
                  }
                  return onBlur;
                }()
              }
            }
          },
          editLines: {
            schemaType: "Object",
            properties: {
              enable: {
                schemaType: "Boolean",
                onBlur: function () {
                  var _onBlur25 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee28(p) {
                    return (0, _regeneratorRuntime2["default"])().wrap(function _callee28$(_context28) {
                      while (1) switch (_context28.prev = _context28.next) {
                        case 0:
                          _context28.next = 2;
                          return updateEditor(p);
                        case 2:
                        case "end":
                          return _context28.stop();
                      }
                    }, _callee28);
                  }));
                  function onBlur(_x30) {
                    return _onBlur25.apply(this, arguments);
                  }
                  return onBlur;
                }()
              },
              color: {
                schemaType: "String",
                onBlur: function () {
                  var _onBlur26 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee29(p) {
                    return (0, _regeneratorRuntime2["default"])().wrap(function _callee29$(_context29) {
                      while (1) switch (_context29.prev = _context29.next) {
                        case 0:
                          _context29.next = 2;
                          return updateEditor(p);
                        case 2:
                        case "end":
                          return _context29.stop();
                      }
                    }, _callee29);
                  }));
                  function onBlur(_x31) {
                    return _onBlur26.apply(this, arguments);
                  }
                  return onBlur;
                }()
              },
              linewidth: {
                schemaType: "Number",
                onBlur: function () {
                  var _onBlur27 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee30(p) {
                    return (0, _regeneratorRuntime2["default"])().wrap(function _callee30$(_context30) {
                      while (1) switch (_context30.prev = _context30.next) {
                        case 0:
                          _context30.next = 2;
                          return updateEditor(p);
                        case 2:
                        case "end":
                          return _context30.stop();
                      }
                    }, _callee30);
                  }));
                  function onBlur(_x32) {
                    return _onBlur27.apply(this, arguments);
                  }
                  return onBlur;
                }()
              }
            }
          },
          calloutNotations: {
            schemaType: "Object",
            properties: {
              enable: {
                schemaType: "Boolean",
                onBlur: function () {
                  var _onBlur28 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee31(p) {
                    return (0, _regeneratorRuntime2["default"])().wrap(function _callee31$(_context31) {
                      while (1) switch (_context31.prev = _context31.next) {
                        case 0:
                          _context31.next = 2;
                          return updateEditor(p);
                        case 2:
                        case "end":
                          return _context31.stop();
                      }
                    }, _callee31);
                  }));
                  function onBlur(_x33) {
                    return _onBlur28.apply(this, arguments);
                  }
                  return onBlur;
                }()
              }
            }
          },
          camera: {
            schemaType: "Object",
            properties: {
              d: {
                schemaType: "Number",
                onBlur: function () {
                  var _onBlur29 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee32(p) {
                    return (0, _regeneratorRuntime2["default"])().wrap(function _callee32$(_context32) {
                      while (1) switch (_context32.prev = _context32.next) {
                        case 0:
                          _context32.next = 2;
                          return updateEditor(p);
                        case 2:
                        case "end":
                          return _context32.stop();
                      }
                    }, _callee32);
                  }));
                  function onBlur(_x34) {
                    return _onBlur29.apply(this, arguments);
                  }
                  return onBlur;
                }()
              },
              fov: {
                schemaType: "Number",
                onBlur: function () {
                  var _onBlur30 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee33(p) {
                    return (0, _regeneratorRuntime2["default"])().wrap(function _callee33$(_context33) {
                      while (1) switch (_context33.prev = _context33.next) {
                        case 0:
                          _context33.next = 2;
                          return updateEditor(p);
                        case 2:
                        case "end":
                          return _context33.stop();
                      }
                    }, _callee33);
                  }));
                  function onBlur(_x35) {
                    return _onBlur30.apply(this, arguments);
                  }
                  return onBlur;
                }()
              },
              type: {
                schemaType: "String",
                onBlur: function () {
                  var _onBlur31 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee34(p) {
                    return (0, _regeneratorRuntime2["default"])().wrap(function _callee34$(_context34) {
                      while (1) switch (_context34.prev = _context34.next) {
                        case 0:
                          _context34.next = 2;
                          return updateEditor(p);
                        case 2:
                        case "end":
                          return _context34.stop();
                      }
                    }, _callee34);
                  }));
                  function onBlur(_x36) {
                    return _onBlur31.apply(this, arguments);
                  }
                  return onBlur;
                }()
              }
            }
          }
        }
      },
      compositions: {
        schemaType: "Array",
        add: function () {
          var _add2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee35(p) {
            var props, setValue, _props$value2, value;
            return (0, _regeneratorRuntime2["default"])().wrap(function _callee35$(_context35) {
              while (1) switch (_context35.prev = _context35.next) {
                case 0:
                  props = p.props;
                  setValue = props.setValue, _props$value2 = props.value, value = _props$value2 === void 0 ? [] : _props$value2;
                  value.push((0, _objectSpread2["default"])({}, JSON.parse(JSON.stringify(_defaultAppData["default"].compositions[0]))));
                  _context35.next = 5;
                  return setValue(value, true);
                case 5:
                  _context35.next = 7;
                  return updateEditor(p);
                case 7:
                case "end":
                  return _context35.stop();
              }
            }, _callee35);
          }));
          function add(_x37) {
            return _add2.apply(this, arguments);
          }
          return add;
        }(),
        items: {
          schemaType: "Object",
          generateLabel: generateLabelForArrayItems,
          useEffectForLabel: subscribePropertiesForLabelForArrayItems,
          enableDelete: true,
          onDelete: function () {
            var _onDelete2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee36(p) {
              return (0, _regeneratorRuntime2["default"])().wrap(function _callee36$(_context36) {
                while (1) switch (_context36.prev = _context36.next) {
                  case 0:
                    _context36.next = 2;
                    return updateEditor(p);
                  case 2:
                  case "end":
                    return _context36.stop();
                }
              }, _callee36);
            }));
            function onDelete(_x38) {
              return _onDelete2.apply(this, arguments);
            }
            return onDelete;
          }(),
          properties: {
            data: {
              schemaType: "Array",
              add: function () {
                var _add3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee37(_ref7) {
                  var props, rest, setValue, _props$value3, value;
                  return (0, _regeneratorRuntime2["default"])().wrap(function _callee37$(_context37) {
                    while (1) switch (_context37.prev = _context37.next) {
                      case 0:
                        props = _ref7.props, rest = (0, _objectWithoutProperties2["default"])(_ref7, _excluded2);
                        setValue = props.setValue, _props$value3 = props.value, value = _props$value3 === void 0 ? [] : _props$value3;
                        value.push({
                          width: 6,
                          height: 0.9,
                          depth: 9,
                          material: {
                            color: 0xe7b508,
                            opacity: 0.95
                          },
                          position: {
                            x: -10,
                            y: 0,
                            z: 0.12
                          }
                        });
                        _context37.next = 5;
                        return setValue(value, true);
                      case 5:
                        _context37.next = 7;
                        return updateEditor((0, _objectSpread2["default"])({
                          props: props
                        }, rest));
                      case 7:
                      case "end":
                        return _context37.stop();
                    }
                  }, _callee37);
                }));
                function add(_x39) {
                  return _add3.apply(this, arguments);
                }
                return add;
              }(),
              items: {
                schemaType: "Object",
                generateLabel: generateLabelForArrayItems,
                useEffectForLabel: subscribePropertiesForLabelForArrayItems,
                enableDelete: function enableDelete(_ref8) {
                  var props = _ref8.props;
                  return props.parentValue && props.parentValue.length ? props.propertyKey && props.propertyKey > 0 : false;
                },
                onDelete: function () {
                  var _onDelete3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee38(p) {
                    return (0, _regeneratorRuntime2["default"])().wrap(function _callee38$(_context38) {
                      while (1) switch (_context38.prev = _context38.next) {
                        case 0:
                          _context38.next = 2;
                          return updateEditor(p);
                        case 2:
                        case "end":
                          return _context38.stop();
                      }
                    }, _callee38);
                  }));
                  function onDelete(_x40) {
                    return _onDelete3.apply(this, arguments);
                  }
                  return onDelete;
                }(),
                properties: {
                  geometryType: {
                    schemaType: "String",
                    onBlur: function () {
                      var _onBlur32 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee39(p) {
                        return (0, _regeneratorRuntime2["default"])().wrap(function _callee39$(_context39) {
                          while (1) switch (_context39.prev = _context39.next) {
                            case 0:
                              _context39.next = 2;
                              return updateEditor(p);
                            case 2:
                            case "end":
                              return _context39.stop();
                          }
                        }, _callee39);
                      }));
                      function onBlur(_x41) {
                        return _onBlur32.apply(this, arguments);
                      }
                      return onBlur;
                    }()
                  },
                  geometryProps: {
                    schemaType: "Array",
                    add: function () {
                      var _add4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee40(_ref9) {
                        var props, rest, setValue, _props$value4, value;
                        return (0, _regeneratorRuntime2["default"])().wrap(function _callee40$(_context40) {
                          while (1) switch (_context40.prev = _context40.next) {
                            case 0:
                              props = _ref9.props, rest = (0, _objectWithoutProperties2["default"])(_ref9, _excluded3);
                              setValue = props.setValue, _props$value4 = props.value, value = _props$value4 === void 0 ? [] : _props$value4;
                              value.push(1);
                              _context40.next = 5;
                              return setValue(value, true);
                            case 5:
                              _context40.next = 7;
                              return updateEditor((0, _objectSpread2["default"])({
                                props: props
                              }, rest));
                            case 7:
                            case "end":
                              return _context40.stop();
                          }
                        }, _callee40);
                      }));
                      function add(_x42) {
                        return _add4.apply(this, arguments);
                      }
                      return add;
                    }(),
                    items: {
                      schemaType: "Number",
                      generateLabel: generateLabelForArrayItems,
                      useEffectForLabel: subscribePropertiesForLabelForArrayItems,
                      onDelete: function () {
                        var _onDelete4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee41(p) {
                          return (0, _regeneratorRuntime2["default"])().wrap(function _callee41$(_context41) {
                            while (1) switch (_context41.prev = _context41.next) {
                              case 0:
                                _context41.next = 2;
                                return updateEditor(p);
                              case 2:
                              case "end":
                                return _context41.stop();
                            }
                          }, _callee41);
                        }));
                        function onDelete(_x43) {
                          return _onDelete4.apply(this, arguments);
                        }
                        return onDelete;
                      }()
                    }
                  },
                  lineProps: {
                    schemaType: "Object",
                    properties: {
                      opacity: {
                        schemaType: "Number",
                        onBlur: function () {
                          var _onBlur33 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee42(p) {
                            return (0, _regeneratorRuntime2["default"])().wrap(function _callee42$(_context42) {
                              while (1) switch (_context42.prev = _context42.next) {
                                case 0:
                                  _context42.next = 2;
                                  return updateEditor(p);
                                case 2:
                                case "end":
                                  return _context42.stop();
                              }
                            }, _callee42);
                          }));
                          function onBlur(_x44) {
                            return _onBlur33.apply(this, arguments);
                          }
                          return onBlur;
                        }()
                      },
                      color: {
                        schemaType: "String",
                        onBlur: function () {
                          var _onBlur34 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee43(p) {
                            return (0, _regeneratorRuntime2["default"])().wrap(function _callee43$(_context43) {
                              while (1) switch (_context43.prev = _context43.next) {
                                case 0:
                                  _context43.next = 2;
                                  return updateEditor(p);
                                case 2:
                                case "end":
                                  return _context43.stop();
                              }
                            }, _callee43);
                          }));
                          function onBlur(_x45) {
                            return _onBlur34.apply(this, arguments);
                          }
                          return onBlur;
                        }()
                      },
                      linewidth: {
                        schemaType: "Number",
                        onBlur: function () {
                          var _onBlur35 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee44(p) {
                            return (0, _regeneratorRuntime2["default"])().wrap(function _callee44$(_context44) {
                              while (1) switch (_context44.prev = _context44.next) {
                                case 0:
                                  _context44.next = 2;
                                  return updateEditor(p);
                                case 2:
                                case "end":
                                  return _context44.stop();
                              }
                            }, _callee44);
                          }));
                          function onBlur(_x46) {
                            return _onBlur35.apply(this, arguments);
                          }
                          return onBlur;
                        }()
                      },
                      disable: {
                        schemaType: "Number",
                        onBlur: function () {
                          var _onBlur36 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee45(p) {
                            return (0, _regeneratorRuntime2["default"])().wrap(function _callee45$(_context45) {
                              while (1) switch (_context45.prev = _context45.next) {
                                case 0:
                                  _context45.next = 2;
                                  return updateEditor(p);
                                case 2:
                                case "end":
                                  return _context45.stop();
                              }
                            }, _callee45);
                          }));
                          function onBlur(_x47) {
                            return _onBlur36.apply(this, arguments);
                          }
                          return onBlur;
                        }()
                      }
                    }
                  },
                  editLines: {
                    schemaType: "Object",
                    properties: {
                      color: {
                        schemaType: "String",
                        onBlur: function () {
                          var _onBlur37 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee46(p) {
                            return (0, _regeneratorRuntime2["default"])().wrap(function _callee46$(_context46) {
                              while (1) switch (_context46.prev = _context46.next) {
                                case 0:
                                  _context46.next = 2;
                                  return updateEditor(p);
                                case 2:
                                case "end":
                                  return _context46.stop();
                              }
                            }, _callee46);
                          }));
                          function onBlur(_x48) {
                            return _onBlur37.apply(this, arguments);
                          }
                          return onBlur;
                        }()
                      },
                      linewidth: {
                        schemaType: "Number",
                        onBlur: function () {
                          var _onBlur38 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee47(p) {
                            return (0, _regeneratorRuntime2["default"])().wrap(function _callee47$(_context47) {
                              while (1) switch (_context47.prev = _context47.next) {
                                case 0:
                                  _context47.next = 2;
                                  return updateEditor(p);
                                case 2:
                                case "end":
                                  return _context47.stop();
                              }
                            }, _callee47);
                          }));
                          function onBlur(_x49) {
                            return _onBlur38.apply(this, arguments);
                          }
                          return onBlur;
                        }()
                      },
                      disable: {
                        schemaType: "Boolean",
                        onBlur: function () {
                          var _onBlur39 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee48(p) {
                            return (0, _regeneratorRuntime2["default"])().wrap(function _callee48$(_context48) {
                              while (1) switch (_context48.prev = _context48.next) {
                                case 0:
                                  _context48.next = 2;
                                  return updateEditor(p);
                                case 2:
                                case "end":
                                  return _context48.stop();
                              }
                            }, _callee48);
                          }));
                          function onBlur(_x50) {
                            return _onBlur39.apply(this, arguments);
                          }
                          return onBlur;
                        }()
                      }
                    }
                  },
                  width: {
                    schemaType: "Number",
                    onBlur: function () {
                      var _onBlur40 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee49(p) {
                        return (0, _regeneratorRuntime2["default"])().wrap(function _callee49$(_context49) {
                          while (1) switch (_context49.prev = _context49.next) {
                            case 0:
                              _context49.next = 2;
                              return updateEditor(p);
                            case 2:
                            case "end":
                              return _context49.stop();
                          }
                        }, _callee49);
                      }));
                      function onBlur(_x51) {
                        return _onBlur40.apply(this, arguments);
                      }
                      return onBlur;
                    }()
                  },
                  height: {
                    schemaType: "Number",
                    onBlur: function () {
                      var _onBlur41 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee50(p) {
                        return (0, _regeneratorRuntime2["default"])().wrap(function _callee50$(_context50) {
                          while (1) switch (_context50.prev = _context50.next) {
                            case 0:
                              _context50.next = 2;
                              return updateEditor(p);
                            case 2:
                            case "end":
                              return _context50.stop();
                          }
                        }, _callee50);
                      }));
                      function onBlur(_x52) {
                        return _onBlur41.apply(this, arguments);
                      }
                      return onBlur;
                    }()
                  },
                  depth: {
                    schemaType: "Number",
                    onBlur: function () {
                      var _onBlur42 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee51(p) {
                        return (0, _regeneratorRuntime2["default"])().wrap(function _callee51$(_context51) {
                          while (1) switch (_context51.prev = _context51.next) {
                            case 0:
                              _context51.next = 2;
                              return updateEditor(p);
                            case 2:
                            case "end":
                              return _context51.stop();
                          }
                        }, _callee51);
                      }));
                      function onBlur(_x53) {
                        return _onBlur42.apply(this, arguments);
                      }
                      return onBlur;
                    }()
                  },
                  material: {
                    schemaType: "Object",
                    properties: {
                      color: {
                        schemaType: "String",
                        onBlur: function () {
                          var _onBlur43 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee52(p) {
                            return (0, _regeneratorRuntime2["default"])().wrap(function _callee52$(_context52) {
                              while (1) switch (_context52.prev = _context52.next) {
                                case 0:
                                  _context52.next = 2;
                                  return updateEditor(p);
                                case 2:
                                case "end":
                                  return _context52.stop();
                              }
                            }, _callee52);
                          }));
                          function onBlur(_x54) {
                            return _onBlur43.apply(this, arguments);
                          }
                          return onBlur;
                        }()
                      },
                      opacity: {
                        schemaType: "Number",
                        onBlur: function () {
                          var _onBlur44 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee53(p) {
                            return (0, _regeneratorRuntime2["default"])().wrap(function _callee53$(_context53) {
                              while (1) switch (_context53.prev = _context53.next) {
                                case 0:
                                  _context53.next = 2;
                                  return updateEditor(p);
                                case 2:
                                case "end":
                                  return _context53.stop();
                              }
                            }, _callee53);
                          }));
                          function onBlur(_x55) {
                            return _onBlur44.apply(this, arguments);
                          }
                          return onBlur;
                        }()
                      }
                    }
                  },
                  shadow: {
                    schemaType: "Object",
                    properties: {
                      disableCastShadow: {
                        schemaType: "Boolean",
                        onBlur: function () {
                          var _onBlur45 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee54(p) {
                            return (0, _regeneratorRuntime2["default"])().wrap(function _callee54$(_context54) {
                              while (1) switch (_context54.prev = _context54.next) {
                                case 0:
                                  _context54.next = 2;
                                  return updateEditor(p);
                                case 2:
                                case "end":
                                  return _context54.stop();
                              }
                            }, _callee54);
                          }));
                          function onBlur(_x56) {
                            return _onBlur45.apply(this, arguments);
                          }
                          return onBlur;
                        }()
                      },
                      disableReceiveShadow: {
                        schemaType: "Boolean",
                        onBlur: function () {
                          var _onBlur46 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee55(p) {
                            return (0, _regeneratorRuntime2["default"])().wrap(function _callee55$(_context55) {
                              while (1) switch (_context55.prev = _context55.next) {
                                case 0:
                                  _context55.next = 2;
                                  return updateEditor(p);
                                case 2:
                                case "end":
                                  return _context55.stop();
                              }
                            }, _callee55);
                          }));
                          function onBlur(_x57) {
                            return _onBlur46.apply(this, arguments);
                          }
                          return onBlur;
                        }()
                      },
                      opacity: {
                        schemaType: "Number",
                        onBlur: function () {
                          var _onBlur47 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee56(p) {
                            return (0, _regeneratorRuntime2["default"])().wrap(function _callee56$(_context56) {
                              while (1) switch (_context56.prev = _context56.next) {
                                case 0:
                                  _context56.next = 2;
                                  return updateEditor(p);
                                case 2:
                                case "end":
                                  return _context56.stop();
                              }
                            }, _callee56);
                          }));
                          function onBlur(_x58) {
                            return _onBlur47.apply(this, arguments);
                          }
                          return onBlur;
                        }()
                      }
                    }
                  },
                  position: {
                    schemaType: "Object",
                    properties: {
                      x: {
                        schemaType: "Number",
                        onBlur: function () {
                          var _onBlur48 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee57(p) {
                            return (0, _regeneratorRuntime2["default"])().wrap(function _callee57$(_context57) {
                              while (1) switch (_context57.prev = _context57.next) {
                                case 0:
                                  _context57.next = 2;
                                  return updateEditor(p);
                                case 2:
                                case "end":
                                  return _context57.stop();
                              }
                            }, _callee57);
                          }));
                          function onBlur(_x59) {
                            return _onBlur48.apply(this, arguments);
                          }
                          return onBlur;
                        }()
                      },
                      y: {
                        schemaType: "Number",
                        onBlur: function () {
                          var _onBlur49 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee58(p) {
                            return (0, _regeneratorRuntime2["default"])().wrap(function _callee58$(_context58) {
                              while (1) switch (_context58.prev = _context58.next) {
                                case 0:
                                  _context58.next = 2;
                                  return updateEditor(p);
                                case 2:
                                case "end":
                                  return _context58.stop();
                              }
                            }, _callee58);
                          }));
                          function onBlur(_x60) {
                            return _onBlur49.apply(this, arguments);
                          }
                          return onBlur;
                        }()
                      },
                      z: {
                        schemaType: "Number",
                        onBlur: function () {
                          var _onBlur50 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee59(p) {
                            return (0, _regeneratorRuntime2["default"])().wrap(function _callee59$(_context59) {
                              while (1) switch (_context59.prev = _context59.next) {
                                case 0:
                                  _context59.next = 2;
                                  return updateEditor(p);
                                case 2:
                                case "end":
                                  return _context59.stop();
                              }
                            }, _callee59);
                          }));
                          function onBlur(_x61) {
                            return _onBlur50.apply(this, arguments);
                          }
                          return onBlur;
                        }()
                      }
                    }
                  },
                  rotation: {
                    schemaType: "Object",
                    properties: {
                      x: {
                        schemaType: "Number",
                        onBlur: function () {
                          var _onBlur51 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee60(p) {
                            return (0, _regeneratorRuntime2["default"])().wrap(function _callee60$(_context60) {
                              while (1) switch (_context60.prev = _context60.next) {
                                case 0:
                                  _context60.next = 2;
                                  return updateEditor(p);
                                case 2:
                                case "end":
                                  return _context60.stop();
                              }
                            }, _callee60);
                          }));
                          function onBlur(_x62) {
                            return _onBlur51.apply(this, arguments);
                          }
                          return onBlur;
                        }()
                      },
                      y: {
                        schemaType: "Number",
                        onBlur: function () {
                          var _onBlur52 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee61(p) {
                            return (0, _regeneratorRuntime2["default"])().wrap(function _callee61$(_context61) {
                              while (1) switch (_context61.prev = _context61.next) {
                                case 0:
                                  _context61.next = 2;
                                  return updateEditor(p);
                                case 2:
                                case "end":
                                  return _context61.stop();
                              }
                            }, _callee61);
                          }));
                          function onBlur(_x63) {
                            return _onBlur52.apply(this, arguments);
                          }
                          return onBlur;
                        }()
                      },
                      z: {
                        schemaType: "Number",
                        onBlur: function () {
                          var _onBlur53 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee62(p) {
                            return (0, _regeneratorRuntime2["default"])().wrap(function _callee62$(_context62) {
                              while (1) switch (_context62.prev = _context62.next) {
                                case 0:
                                  _context62.next = 2;
                                  return updateEditor(p);
                                case 2:
                                case "end":
                                  return _context62.stop();
                              }
                            }, _callee62);
                          }));
                          function onBlur(_x64) {
                            return _onBlur53.apply(this, arguments);
                          }
                          return onBlur;
                        }()
                      }
                    }
                  },
                  calloutNotation: {
                    schemaType: "Object",
                    properties: {
                      text: {
                        schemaType: "String",
                        onBlur: function () {
                          var _onBlur54 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee63(p) {
                            return (0, _regeneratorRuntime2["default"])().wrap(function _callee63$(_context63) {
                              while (1) switch (_context63.prev = _context63.next) {
                                case 0:
                                  _context63.next = 2;
                                  return updateEditor(p);
                                case 2:
                                case "end":
                                  return _context63.stop();
                              }
                            }, _callee63);
                          }));
                          function onBlur(_x65) {
                            return _onBlur54.apply(this, arguments);
                          }
                          return onBlur;
                        }()
                      },
                      position: {
                        schemaType: "Object",
                        properties: {
                          x: {
                            schemaType: "Number",
                            onBlur: function () {
                              var _onBlur55 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee64(p) {
                                return (0, _regeneratorRuntime2["default"])().wrap(function _callee64$(_context64) {
                                  while (1) switch (_context64.prev = _context64.next) {
                                    case 0:
                                      _context64.next = 2;
                                      return updateEditor(p);
                                    case 2:
                                    case "end":
                                      return _context64.stop();
                                  }
                                }, _callee64);
                              }));
                              function onBlur(_x66) {
                                return _onBlur55.apply(this, arguments);
                              }
                              return onBlur;
                            }()
                          },
                          y: {
                            schemaType: "Number",
                            onBlur: function () {
                              var _onBlur56 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee65(p) {
                                return (0, _regeneratorRuntime2["default"])().wrap(function _callee65$(_context65) {
                                  while (1) switch (_context65.prev = _context65.next) {
                                    case 0:
                                      _context65.next = 2;
                                      return updateEditor(p);
                                    case 2:
                                    case "end":
                                      return _context65.stop();
                                  }
                                }, _callee65);
                              }));
                              function onBlur(_x67) {
                                return _onBlur56.apply(this, arguments);
                              }
                              return onBlur;
                            }()
                          },
                          z: {
                            schemaType: "Number",
                            onBlur: function () {
                              var _onBlur57 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee66(p) {
                                return (0, _regeneratorRuntime2["default"])().wrap(function _callee66$(_context66) {
                                  while (1) switch (_context66.prev = _context66.next) {
                                    case 0:
                                      _context66.next = 2;
                                      return updateEditor(p);
                                    case 2:
                                    case "end":
                                      return _context66.stop();
                                  }
                                }, _callee66);
                              }));
                              function onBlur(_x68) {
                                return _onBlur57.apply(this, arguments);
                              }
                              return onBlur;
                            }()
                          }
                        }
                      },
                      boundingX: {
                        schemaType: "String",
                        onBlur: function () {
                          var _onBlur58 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee67(p) {
                            return (0, _regeneratorRuntime2["default"])().wrap(function _callee67$(_context67) {
                              while (1) switch (_context67.prev = _context67.next) {
                                case 0:
                                  _context67.next = 2;
                                  return updateEditor(p);
                                case 2:
                                case "end":
                                  return _context67.stop();
                              }
                            }, _callee67);
                          }));
                          function onBlur(_x69) {
                            return _onBlur58.apply(this, arguments);
                          }
                          return onBlur;
                        }()
                      },
                      font: {
                        schemaType: "String",
                        onBlur: function () {
                          var _onBlur59 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee68(p) {
                            return (0, _regeneratorRuntime2["default"])().wrap(function _callee68$(_context68) {
                              while (1) switch (_context68.prev = _context68.next) {
                                case 0:
                                  _context68.next = 2;
                                  return updateEditor(p);
                                case 2:
                                case "end":
                                  return _context68.stop();
                              }
                            }, _callee68);
                          }));
                          function onBlur(_x70) {
                            return _onBlur59.apply(this, arguments);
                          }
                          return onBlur;
                        }()
                      },
                      size: {
                        schemaType: "Number",
                        onBlur: function () {
                          var _onBlur60 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee69(p) {
                            return (0, _regeneratorRuntime2["default"])().wrap(function _callee69$(_context69) {
                              while (1) switch (_context69.prev = _context69.next) {
                                case 0:
                                  _context69.next = 2;
                                  return updateEditor(p);
                                case 2:
                                case "end":
                                  return _context69.stop();
                              }
                            }, _callee69);
                          }));
                          function onBlur(_x71) {
                            return _onBlur60.apply(this, arguments);
                          }
                          return onBlur;
                        }()
                      },
                      color: {
                        schemaType: "String",
                        onBlur: function () {
                          var _onBlur61 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee70(p) {
                            return (0, _regeneratorRuntime2["default"])().wrap(function _callee70$(_context70) {
                              while (1) switch (_context70.prev = _context70.next) {
                                case 0:
                                  _context70.next = 2;
                                  return updateEditor(p);
                                case 2:
                                case "end":
                                  return _context70.stop();
                              }
                            }, _callee70);
                          }));
                          function onBlur(_x72) {
                            return _onBlur61.apply(this, arguments);
                          }
                          return onBlur;
                        }()
                      },
                      opacity: {
                        schemaType: "Number",
                        onBlur: function () {
                          var _onBlur62 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee71(p) {
                            return (0, _regeneratorRuntime2["default"])().wrap(function _callee71$(_context71) {
                              while (1) switch (_context71.prev = _context71.next) {
                                case 0:
                                  _context71.next = 2;
                                  return updateEditor(p);
                                case 2:
                                case "end":
                                  return _context71.stop();
                              }
                            }, _callee71);
                          }));
                          function onBlur(_x73) {
                            return _onBlur62.apply(this, arguments);
                          }
                          return onBlur;
                        }()
                      },
                      lineProps: {
                        schemaType: "Object",
                        properties: {
                          opacity: {
                            schemaType: "Number",
                            onBlur: function () {
                              var _onBlur63 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee72(p) {
                                return (0, _regeneratorRuntime2["default"])().wrap(function _callee72$(_context72) {
                                  while (1) switch (_context72.prev = _context72.next) {
                                    case 0:
                                      _context72.next = 2;
                                      return updateEditor(p);
                                    case 2:
                                    case "end":
                                      return _context72.stop();
                                  }
                                }, _callee72);
                              }));
                              function onBlur(_x74) {
                                return _onBlur63.apply(this, arguments);
                              }
                              return onBlur;
                            }()
                          },
                          color: {
                            schemaType: "String",
                            onBlur: function () {
                              var _onBlur64 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee73(p) {
                                return (0, _regeneratorRuntime2["default"])().wrap(function _callee73$(_context73) {
                                  while (1) switch (_context73.prev = _context73.next) {
                                    case 0:
                                      _context73.next = 2;
                                      return updateEditor(p);
                                    case 2:
                                    case "end":
                                      return _context73.stop();
                                  }
                                }, _callee73);
                              }));
                              function onBlur(_x75) {
                                return _onBlur64.apply(this, arguments);
                              }
                              return onBlur;
                            }()
                          },
                          linewidth: {
                            schemaType: "Number",
                            onBlur: function () {
                              var _onBlur65 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee74(p) {
                                return (0, _regeneratorRuntime2["default"])().wrap(function _callee74$(_context74) {
                                  while (1) switch (_context74.prev = _context74.next) {
                                    case 0:
                                      _context74.next = 2;
                                      return updateEditor(p);
                                    case 2:
                                    case "end":
                                      return _context74.stop();
                                  }
                                }, _callee74);
                              }));
                              function onBlur(_x76) {
                                return _onBlur65.apply(this, arguments);
                              }
                              return onBlur;
                            }()
                          },
                          disable: {
                            schemaType: "Number",
                            onBlur: function () {
                              var _onBlur66 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee75(p) {
                                return (0, _regeneratorRuntime2["default"])().wrap(function _callee75$(_context75) {
                                  while (1) switch (_context75.prev = _context75.next) {
                                    case 0:
                                      _context75.next = 2;
                                      return updateEditor(p);
                                    case 2:
                                    case "end":
                                      return _context75.stop();
                                  }
                                }, _callee75);
                              }));
                              function onBlur(_x77) {
                                return _onBlur66.apply(this, arguments);
                              }
                              return onBlur;
                            }()
                          }
                        }
                      }
                    }
                  },
                  camera: {
                    schemaType: "Object",
                    properties: {
                      "0": getCameraDataForObject(),
                      "2": getCameraDataForObject(),
                      "3": getCameraDataForObject(),
                      "4": getCameraDataForObject()
                    }
                  },
                  group: {
                    schemaType: "String"
                  }
                }
              }
            },
            background: {
              schemaType: "String",
              onBlur: function () {
                var _onBlur67 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee76(p) {
                  return (0, _regeneratorRuntime2["default"])().wrap(function _callee76$(_context76) {
                    while (1) switch (_context76.prev = _context76.next) {
                      case 0:
                        _context76.next = 2;
                        return updateEditor(p);
                      case 2:
                      case "end":
                        return _context76.stop();
                    }
                  }, _callee76);
                }));
                function onBlur(_x78) {
                  return _onBlur67.apply(this, arguments);
                }
                return onBlur;
              }()
            },
            canvasBackground: {
              schemaType: "Array",
              add: function () {
                var _add5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee77(_ref10) {
                  var props, rest, setValue, _props$value5, value;
                  return (0, _regeneratorRuntime2["default"])().wrap(function _callee77$(_context77) {
                    while (1) switch (_context77.prev = _context77.next) {
                      case 0:
                        props = _ref10.props, rest = (0, _objectWithoutProperties2["default"])(_ref10, _excluded4);
                        setValue = props.setValue, _props$value5 = props.value, value = _props$value5 === void 0 ? [] : _props$value5;
                        value.push({
                          type: "canvas1",
                          props: ["#f9f7f0", "#faf5df"]
                        });
                        _context77.next = 5;
                        return setValue(value, true);
                      case 5:
                        _context77.next = 7;
                        return updateEditor((0, _objectSpread2["default"])({
                          props: props
                        }, rest));
                      case 7:
                      case "end":
                        return _context77.stop();
                    }
                  }, _callee77);
                }));
                function add(_x79) {
                  return _add5.apply(this, arguments);
                }
                return add;
              }(),
              items: {
                schemaType: "Object",
                generateLabel: generateLabelForArrayItems,
                useEffectForLabel: subscribePropertiesForLabelForArrayItems,
                onDelete: function () {
                  var _onDelete5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee78(p) {
                    return (0, _regeneratorRuntime2["default"])().wrap(function _callee78$(_context78) {
                      while (1) switch (_context78.prev = _context78.next) {
                        case 0:
                          _context78.next = 2;
                          return updateEditor(p);
                        case 2:
                        case "end":
                          return _context78.stop();
                      }
                    }, _callee78);
                  }));
                  function onDelete(_x80) {
                    return _onDelete5.apply(this, arguments);
                  }
                  return onDelete;
                }(),
                properties: {
                  type: {
                    schemaType: "String",
                    onBlur: function () {
                      var _onBlur68 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee79(p) {
                        return (0, _regeneratorRuntime2["default"])().wrap(function _callee79$(_context79) {
                          while (1) switch (_context79.prev = _context79.next) {
                            case 0:
                              _context79.next = 2;
                              return updateEditor(p);
                            case 2:
                            case "end":
                              return _context79.stop();
                          }
                        }, _callee79);
                      }));
                      function onBlur(_x81) {
                        return _onBlur68.apply(this, arguments);
                      }
                      return onBlur;
                    }()
                  },
                  props: {
                    schemaType: "Array",
                    add: function () {
                      var _add6 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee80(_ref11) {
                        var props, setValue, _props$value6, value;
                        return (0, _regeneratorRuntime2["default"])().wrap(function _callee80$(_context80) {
                          while (1) switch (_context80.prev = _context80.next) {
                            case 0:
                              props = _ref11.props;
                              setValue = props.setValue, _props$value6 = props.value, value = _props$value6 === void 0 ? [] : _props$value6;
                              value.push("");
                              _context80.next = 5;
                              return setValue(value, true);
                            case 5:
                            case "end":
                              return _context80.stop();
                          }
                        }, _callee80);
                      }));
                      function add(_x82) {
                        return _add6.apply(this, arguments);
                      }
                      return add;
                    }(),
                    items: {
                      schemaType: "String",
                      enableDelete: true
                    }
                  }
                }
              }
            },
            cameraPosition: {
              schemaType: "Object",
              properties: {
                x: {
                  schemaType: "Number",
                  onBlur: function () {
                    var _onBlur69 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee81(p) {
                      return (0, _regeneratorRuntime2["default"])().wrap(function _callee81$(_context81) {
                        while (1) switch (_context81.prev = _context81.next) {
                          case 0:
                            _context81.next = 2;
                            return updateEditor(p);
                          case 2:
                          case "end":
                            return _context81.stop();
                        }
                      }, _callee81);
                    }));
                    function onBlur(_x83) {
                      return _onBlur69.apply(this, arguments);
                    }
                    return onBlur;
                  }()
                },
                y: {
                  schemaType: "Number",
                  onBlur: function () {
                    var _onBlur70 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee82(p) {
                      return (0, _regeneratorRuntime2["default"])().wrap(function _callee82$(_context82) {
                        while (1) switch (_context82.prev = _context82.next) {
                          case 0:
                            _context82.next = 2;
                            return updateEditor(p);
                          case 2:
                          case "end":
                            return _context82.stop();
                        }
                      }, _callee82);
                    }));
                    function onBlur(_x84) {
                      return _onBlur70.apply(this, arguments);
                    }
                    return onBlur;
                  }()
                },
                z: {
                  schemaType: "Number",
                  onBlur: function () {
                    var _onBlur71 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee83(p) {
                      return (0, _regeneratorRuntime2["default"])().wrap(function _callee83$(_context83) {
                        while (1) switch (_context83.prev = _context83.next) {
                          case 0:
                            _context83.next = 2;
                            return updateEditor(p);
                          case 2:
                          case "end":
                            return _context83.stop();
                        }
                      }, _callee83);
                    }));
                    function onBlur(_x85) {
                      return _onBlur71.apply(this, arguments);
                    }
                    return onBlur;
                  }()
                }
              }
            },
            cameraZoom: {
              schemaType: "Number",
              onBlur: function () {
                var _onBlur72 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee84(p) {
                  return (0, _regeneratorRuntime2["default"])().wrap(function _callee84$(_context84) {
                    while (1) switch (_context84.prev = _context84.next) {
                      case 0:
                        _context84.next = 2;
                        return updateEditor(p);
                      case 2:
                      case "end":
                        return _context84.stop();
                    }
                  }, _callee84);
                }));
                function onBlur(_x86) {
                  return _onBlur72.apply(this, arguments);
                }
                return onBlur;
              }()
            },
            cameraUp: {
              schemaType: "Object",
              properties: {
                x: {
                  schemaType: "Number",
                  onBlur: function () {
                    var _onBlur73 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee85(p) {
                      return (0, _regeneratorRuntime2["default"])().wrap(function _callee85$(_context85) {
                        while (1) switch (_context85.prev = _context85.next) {
                          case 0:
                            _context85.next = 2;
                            return updateEditor(p);
                          case 2:
                          case "end":
                            return _context85.stop();
                        }
                      }, _callee85);
                    }));
                    function onBlur(_x87) {
                      return _onBlur73.apply(this, arguments);
                    }
                    return onBlur;
                  }()
                },
                y: {
                  schemaType: "Number",
                  onBlur: function () {
                    var _onBlur74 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee86(p) {
                      return (0, _regeneratorRuntime2["default"])().wrap(function _callee86$(_context86) {
                        while (1) switch (_context86.prev = _context86.next) {
                          case 0:
                            _context86.next = 2;
                            return updateEditor(p);
                          case 2:
                          case "end":
                            return _context86.stop();
                        }
                      }, _callee86);
                    }));
                    function onBlur(_x88) {
                      return _onBlur74.apply(this, arguments);
                    }
                    return onBlur;
                  }()
                },
                z: {
                  schemaType: "Number",
                  onBlur: function () {
                    var _onBlur75 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee87(p) {
                      return (0, _regeneratorRuntime2["default"])().wrap(function _callee87$(_context87) {
                        while (1) switch (_context87.prev = _context87.next) {
                          case 0:
                            _context87.next = 2;
                            return updateEditor(p);
                          case 2:
                          case "end":
                            return _context87.stop();
                        }
                      }, _callee87);
                    }));
                    function onBlur(_x89) {
                      return _onBlur75.apply(this, arguments);
                    }
                    return onBlur;
                  }()
                }
              }
            },
            cameraTarget: {
              schemaType: "Object",
              properties: {
                x: {
                  schemaType: "Number",
                  onBlur: function () {
                    var _onBlur76 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee88(p) {
                      return (0, _regeneratorRuntime2["default"])().wrap(function _callee88$(_context88) {
                        while (1) switch (_context88.prev = _context88.next) {
                          case 0:
                            _context88.next = 2;
                            return updateEditor(p);
                          case 2:
                          case "end":
                            return _context88.stop();
                        }
                      }, _callee88);
                    }));
                    function onBlur(_x90) {
                      return _onBlur76.apply(this, arguments);
                    }
                    return onBlur;
                  }()
                },
                y: {
                  schemaType: "Number",
                  onBlur: function () {
                    var _onBlur77 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee89(p) {
                      return (0, _regeneratorRuntime2["default"])().wrap(function _callee89$(_context89) {
                        while (1) switch (_context89.prev = _context89.next) {
                          case 0:
                            _context89.next = 2;
                            return updateEditor(p);
                          case 2:
                          case "end":
                            return _context89.stop();
                        }
                      }, _callee89);
                    }));
                    function onBlur(_x91) {
                      return _onBlur77.apply(this, arguments);
                    }
                    return onBlur;
                  }()
                },
                z: {
                  schemaType: "Number",
                  onBlur: function () {
                    var _onBlur78 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee90(p) {
                      return (0, _regeneratorRuntime2["default"])().wrap(function _callee90$(_context90) {
                        while (1) switch (_context90.prev = _context90.next) {
                          case 0:
                            _context90.next = 2;
                            return updateEditor(p);
                          case 2:
                          case "end":
                            return _context90.stop();
                        }
                      }, _callee90);
                    }));
                    function onBlur(_x92) {
                      return _onBlur78.apply(this, arguments);
                    }
                    return onBlur;
                  }()
                }
              }
            },
            objectsPosition: {
              schemaType: "Object",
              properties: {
                x: {
                  schemaType: "Number",
                  onBlur: function () {
                    var _onBlur79 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee91(p) {
                      return (0, _regeneratorRuntime2["default"])().wrap(function _callee91$(_context91) {
                        while (1) switch (_context91.prev = _context91.next) {
                          case 0:
                            _context91.next = 2;
                            return updateEditor(p);
                          case 2:
                          case "end":
                            return _context91.stop();
                        }
                      }, _callee91);
                    }));
                    function onBlur(_x93) {
                      return _onBlur79.apply(this, arguments);
                    }
                    return onBlur;
                  }()
                },
                y: {
                  schemaType: "Number",
                  onBlur: function () {
                    var _onBlur80 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee92(p) {
                      return (0, _regeneratorRuntime2["default"])().wrap(function _callee92$(_context92) {
                        while (1) switch (_context92.prev = _context92.next) {
                          case 0:
                            _context92.next = 2;
                            return updateEditor(p);
                          case 2:
                          case "end":
                            return _context92.stop();
                        }
                      }, _callee92);
                    }));
                    function onBlur(_x94) {
                      return _onBlur80.apply(this, arguments);
                    }
                    return onBlur;
                  }()
                },
                z: {
                  schemaType: "Number",
                  onBlur: function () {
                    var _onBlur81 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee93(p) {
                      return (0, _regeneratorRuntime2["default"])().wrap(function _callee93$(_context93) {
                        while (1) switch (_context93.prev = _context93.next) {
                          case 0:
                            _context93.next = 2;
                            return updateEditor(p);
                          case 2:
                          case "end":
                            return _context93.stop();
                        }
                      }, _callee93);
                    }));
                    function onBlur(_x95) {
                      return _onBlur81.apply(this, arguments);
                    }
                    return onBlur;
                  }()
                }
              }
            },
            objectsRotation: {
              schemaType: "Object",
              properties: {
                x: {
                  schemaType: "Number",
                  onBlur: function () {
                    var _onBlur82 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee94(p) {
                      return (0, _regeneratorRuntime2["default"])().wrap(function _callee94$(_context94) {
                        while (1) switch (_context94.prev = _context94.next) {
                          case 0:
                            _context94.next = 2;
                            return updateEditor(p);
                          case 2:
                          case "end":
                            return _context94.stop();
                        }
                      }, _callee94);
                    }));
                    function onBlur(_x96) {
                      return _onBlur82.apply(this, arguments);
                    }
                    return onBlur;
                  }()
                },
                y: {
                  schemaType: "Number",
                  onBlur: function () {
                    var _onBlur83 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee95(p) {
                      return (0, _regeneratorRuntime2["default"])().wrap(function _callee95$(_context95) {
                        while (1) switch (_context95.prev = _context95.next) {
                          case 0:
                            _context95.next = 2;
                            return updateEditor(p);
                          case 2:
                          case "end":
                            return _context95.stop();
                        }
                      }, _callee95);
                    }));
                    function onBlur(_x97) {
                      return _onBlur83.apply(this, arguments);
                    }
                    return onBlur;
                  }()
                },
                z: {
                  schemaType: "Number",
                  onBlur: function () {
                    var _onBlur84 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee96(p) {
                      return (0, _regeneratorRuntime2["default"])().wrap(function _callee96$(_context96) {
                        while (1) switch (_context96.prev = _context96.next) {
                          case 0:
                            _context96.next = 2;
                            return updateEditor(p);
                          case 2:
                          case "end":
                            return _context96.stop();
                        }
                      }, _callee96);
                    }));
                    function onBlur(_x98) {
                      return _onBlur84.apply(this, arguments);
                    }
                    return onBlur;
                  }()
                }
              }
            },
            controlsProps: {
              schemaType: "Object",
              properties: {
                minPolarAngle: {
                  schemaType: "Number",
                  onBlur: function () {
                    var _onBlur85 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee97(p) {
                      return (0, _regeneratorRuntime2["default"])().wrap(function _callee97$(_context97) {
                        while (1) switch (_context97.prev = _context97.next) {
                          case 0:
                            _context97.next = 2;
                            return updateEditor(p);
                          case 2:
                          case "end":
                            return _context97.stop();
                        }
                      }, _callee97);
                    }));
                    function onBlur(_x99) {
                      return _onBlur85.apply(this, arguments);
                    }
                    return onBlur;
                  }()
                },
                maxPolarAngle: {
                  schemaType: "Number",
                  onBlur: function () {
                    var _onBlur86 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee98(p) {
                      return (0, _regeneratorRuntime2["default"])().wrap(function _callee98$(_context98) {
                        while (1) switch (_context98.prev = _context98.next) {
                          case 0:
                            _context98.next = 2;
                            return updateEditor(p);
                          case 2:
                          case "end":
                            return _context98.stop();
                        }
                      }, _callee98);
                    }));
                    function onBlur(_x100) {
                      return _onBlur86.apply(this, arguments);
                    }
                    return onBlur;
                  }()
                },
                minAzimuthAngle: {
                  schemaType: "Number",
                  onBlur: function () {
                    var _onBlur87 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee99(p) {
                      return (0, _regeneratorRuntime2["default"])().wrap(function _callee99$(_context99) {
                        while (1) switch (_context99.prev = _context99.next) {
                          case 0:
                            _context99.next = 2;
                            return updateEditor(p);
                          case 2:
                          case "end":
                            return _context99.stop();
                        }
                      }, _callee99);
                    }));
                    function onBlur(_x101) {
                      return _onBlur87.apply(this, arguments);
                    }
                    return onBlur;
                  }()
                },
                maxAzimuthAngle: {
                  schemaType: "Number",
                  onBlur: function () {
                    var _onBlur88 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee100(p) {
                      return (0, _regeneratorRuntime2["default"])().wrap(function _callee100$(_context100) {
                        while (1) switch (_context100.prev = _context100.next) {
                          case 0:
                            _context100.next = 2;
                            return updateEditor(p);
                          case 2:
                          case "end":
                            return _context100.stop();
                        }
                      }, _callee100);
                    }));
                    function onBlur(_x102) {
                      return _onBlur88.apply(this, arguments);
                    }
                    return onBlur;
                  }()
                }
              }
            },
            lights: {
              schemaType: "Array",
              add: function () {
                var _add7 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee101(_ref12) {
                  var props, setValue, _props$value7, value;
                  return (0, _regeneratorRuntime2["default"])().wrap(function _callee101$(_context101) {
                    while (1) switch (_context101.prev = _context101.next) {
                      case 0:
                        props = _ref12.props;
                        setValue = props.setValue, _props$value7 = props.value, value = _props$value7 === void 0 ? [] : _props$value7;
                        value.push({});
                        _context101.next = 5;
                        return setValue(value, true);
                      case 5:
                      case "end":
                        return _context101.stop();
                    }
                  }, _callee101);
                }));
                function add(_x103) {
                  return _add7.apply(this, arguments);
                }
                return add;
              }(),
              items: {
                schemaType: "Object",
                enableDelete: true,
                properties: {
                  x: {
                    schemaType: "Number",
                    onBlur: function () {
                      var _onBlur89 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee102(p) {
                        return (0, _regeneratorRuntime2["default"])().wrap(function _callee102$(_context102) {
                          while (1) switch (_context102.prev = _context102.next) {
                            case 0:
                              _context102.next = 2;
                              return updateEditor(p);
                            case 2:
                            case "end":
                              return _context102.stop();
                          }
                        }, _callee102);
                      }));
                      function onBlur(_x104) {
                        return _onBlur89.apply(this, arguments);
                      }
                      return onBlur;
                    }()
                  },
                  y: {
                    schemaType: "Number",
                    onBlur: function () {
                      var _onBlur90 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee103(p) {
                        return (0, _regeneratorRuntime2["default"])().wrap(function _callee103$(_context103) {
                          while (1) switch (_context103.prev = _context103.next) {
                            case 0:
                              _context103.next = 2;
                              return updateEditor(p);
                            case 2:
                            case "end":
                              return _context103.stop();
                          }
                        }, _callee103);
                      }));
                      function onBlur(_x105) {
                        return _onBlur90.apply(this, arguments);
                      }
                      return onBlur;
                    }()
                  },
                  z: {
                    schemaType: "Number",
                    onBlur: function () {
                      var _onBlur91 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee104(p) {
                        return (0, _regeneratorRuntime2["default"])().wrap(function _callee104$(_context104) {
                          while (1) switch (_context104.prev = _context104.next) {
                            case 0:
                              _context104.next = 2;
                              return updateEditor(p);
                            case 2:
                            case "end":
                              return _context104.stop();
                          }
                        }, _callee104);
                      }));
                      function onBlur(_x106) {
                        return _onBlur91.apply(this, arguments);
                      }
                      return onBlur;
                    }()
                  },
                  type: {
                    schemaType: "String",
                    onBlur: function () {
                      var _onBlur92 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee105(p) {
                        return (0, _regeneratorRuntime2["default"])().wrap(function _callee105$(_context105) {
                          while (1) switch (_context105.prev = _context105.next) {
                            case 0:
                              _context105.next = 2;
                              return updateEditor(p);
                            case 2:
                            case "end":
                              return _context105.stop();
                          }
                        }, _callee105);
                      }));
                      function onBlur(_x107) {
                        return _onBlur92.apply(this, arguments);
                      }
                      return onBlur;
                    }()
                  },
                  props: {
                    schemaType: "Array",
                    add: function () {
                      var _add8 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee106(_ref13) {
                        var props, setValue, _props$value8, value;
                        return (0, _regeneratorRuntime2["default"])().wrap(function _callee106$(_context106) {
                          while (1) switch (_context106.prev = _context106.next) {
                            case 0:
                              props = _ref13.props;
                              setValue = props.setValue, _props$value8 = props.value, value = _props$value8 === void 0 ? [] : _props$value8;
                              value.push("");
                              _context106.next = 5;
                              return setValue(value, true);
                            case 5:
                            case "end":
                              return _context106.stop();
                          }
                        }, _callee106);
                      }));
                      function add(_x108) {
                        return _add8.apply(this, arguments);
                      }
                      return add;
                    }(),
                    items: {
                      schemaType: "String",
                      enableDelete: true
                    }
                  }
                }
              }
            },
            ambientLight: {
              schemaType: "Object",
              properties: {
                props: {
                  schemaType: "Array",
                  add: function () {
                    var _add9 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee107(_ref14) {
                      var props, setValue, _props$value9, value;
                      return (0, _regeneratorRuntime2["default"])().wrap(function _callee107$(_context107) {
                        while (1) switch (_context107.prev = _context107.next) {
                          case 0:
                            props = _ref14.props;
                            setValue = props.setValue, _props$value9 = props.value, value = _props$value9 === void 0 ? [] : _props$value9;
                            value.push("");
                            _context107.next = 5;
                            return setValue(value, true);
                          case 5:
                          case "end":
                            return _context107.stop();
                        }
                      }, _callee107);
                    }));
                    function add(_x109) {
                      return _add9.apply(this, arguments);
                    }
                    return add;
                  }(),
                  items: {
                    schemaType: "String",
                    enableDelete: true
                  }
                }
              }
            },
            animation: {
              schemaType: "Array",
              add: function () {
                var _add10 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee108(_ref15) {
                  var props, setValue, _props$value10, value;
                  return (0, _regeneratorRuntime2["default"])().wrap(function _callee108$(_context108) {
                    while (1) switch (_context108.prev = _context108.next) {
                      case 0:
                        props = _ref15.props;
                        setValue = props.setValue, _props$value10 = props.value, value = _props$value10 === void 0 ? [] : _props$value10;
                        value.push("");
                        _context108.next = 5;
                        return setValue(value, true);
                      case 5:
                      case "end":
                        return _context108.stop();
                    }
                  }, _callee108);
                }));
                function add(_x110) {
                  return _add10.apply(this, arguments);
                }
                return add;
              }(),
              items: {
                schemaType: "String",
                enableDelete: true
              }
            },
            animationProps: {
              schemaType: "Object",
              properties: {
                addObjectsAnimationType: {
                  schemaType: "String",
                  onBlur: function () {
                    var _onBlur93 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee109(p) {
                      return (0, _regeneratorRuntime2["default"])().wrap(function _callee109$(_context109) {
                        while (1) switch (_context109.prev = _context109.next) {
                          case 0:
                            _context109.next = 2;
                            return updateEditor(p);
                          case 2:
                          case "end":
                            return _context109.stop();
                        }
                      }, _callee109);
                    }));
                    function onBlur(_x111) {
                      return _onBlur93.apply(this, arguments);
                    }
                    return onBlur;
                  }()
                },
                addObjectsAnimationTime: {
                  schemaType: "Array",
                  add: function () {
                    var _add11 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee110(_ref16) {
                      var props, rest, setValue, _props$value11, value;
                      return (0, _regeneratorRuntime2["default"])().wrap(function _callee110$(_context110) {
                        while (1) switch (_context110.prev = _context110.next) {
                          case 0:
                            props = _ref16.props, rest = (0, _objectWithoutProperties2["default"])(_ref16, _excluded5);
                            setValue = props.setValue, _props$value11 = props.value, value = _props$value11 === void 0 ? [] : _props$value11;
                            if (!(value.length < 2)) {
                              _context110.next = 8;
                              break;
                            }
                            value.push(1000);
                            _context110.next = 6;
                            return setValue(value, true);
                          case 6:
                            _context110.next = 8;
                            return updateEditor((0, _objectSpread2["default"])({
                              props: props
                            }, rest));
                          case 8:
                          case "end":
                            return _context110.stop();
                        }
                      }, _callee110);
                    }));
                    function add(_x112) {
                      return _add11.apply(this, arguments);
                    }
                    return add;
                  }(),
                  items: {
                    schemaType: "Number",
                    generateLabel: generateLabelForArrayItems,
                    useEffectForLabel: subscribePropertiesForLabelForArrayItems,
                    onDelete: function () {
                      var _onDelete6 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee111(p) {
                        return (0, _regeneratorRuntime2["default"])().wrap(function _callee111$(_context111) {
                          while (1) switch (_context111.prev = _context111.next) {
                            case 0:
                              _context111.next = 2;
                              return updateEditor(p);
                            case 2:
                            case "end":
                              return _context111.stop();
                          }
                        }, _callee111);
                      }));
                      function onDelete(_x113) {
                        return _onDelete6.apply(this, arguments);
                      }
                      return onDelete;
                    }()
                  }
                },
                cameraMoveTime: {
                  schemaType: "Number",
                  onBlur: function () {
                    var _onBlur94 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee112(p) {
                      return (0, _regeneratorRuntime2["default"])().wrap(function _callee112$(_context112) {
                        while (1) switch (_context112.prev = _context112.next) {
                          case 0:
                            _context112.next = 2;
                            return updateEditor(p);
                          case 2:
                          case "end":
                            return _context112.stop();
                        }
                      }, _callee112);
                    }));
                    function onBlur(_x114) {
                      return _onBlur94.apply(this, arguments);
                    }
                    return onBlur;
                  }()
                }
              }
            },
            dimensions: {
              schemaType: "Object",
              properties: {
                defaultDimension: {
                  schemaType: "String",
                  onBlur: function () {
                    var _onBlur95 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee113(p) {
                      return (0, _regeneratorRuntime2["default"])().wrap(function _callee113$(_context113) {
                        while (1) switch (_context113.prev = _context113.next) {
                          case 0:
                            _context113.next = 2;
                            return updateEditor(p);
                          case 2:
                          case "end":
                            return _context113.stop();
                        }
                      }, _callee113);
                    }));
                    function onBlur(_x115) {
                      return _onBlur95.apply(this, arguments);
                    }
                    return onBlur;
                  }()
                },
                dimensions: {
                  schemaType: "Array",
                  add: function () {
                    var _add12 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee114(_ref17) {
                      var props, rest, setValue, _props$value12, value;
                      return (0, _regeneratorRuntime2["default"])().wrap(function _callee114$(_context114) {
                        while (1) switch (_context114.prev = _context114.next) {
                          case 0:
                            props = _ref17.props, rest = (0, _objectWithoutProperties2["default"])(_ref17, _excluded6);
                            setValue = props.setValue, _props$value12 = props.value, value = _props$value12 === void 0 ? [] : _props$value12;
                            value.push({
                              width: 0,
                              height: 0,
                              key: "",
                              name: ""
                            });
                            _context114.next = 5;
                            return setValue(value, true);
                          case 5:
                            _context114.next = 7;
                            return updateEditor((0, _objectSpread2["default"])({
                              props: props
                            }, rest));
                          case 7:
                          case "end":
                            return _context114.stop();
                        }
                      }, _callee114);
                    }));
                    function add(_x116) {
                      return _add12.apply(this, arguments);
                    }
                    return add;
                  }(),
                  items: {
                    schemaType: "Object",
                    onDelete: function () {
                      var _onDelete7 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee115(p) {
                        return (0, _regeneratorRuntime2["default"])().wrap(function _callee115$(_context115) {
                          while (1) switch (_context115.prev = _context115.next) {
                            case 0:
                              _context115.next = 2;
                              return updateEditor(p);
                            case 2:
                            case "end":
                              return _context115.stop();
                          }
                        }, _callee115);
                      }));
                      function onDelete(_x117) {
                        return _onDelete7.apply(this, arguments);
                      }
                      return onDelete;
                    }(),
                    properties: {
                      width: {
                        schemaType: "Number",
                        onBlur: function () {
                          var _onBlur96 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee116(p) {
                            return (0, _regeneratorRuntime2["default"])().wrap(function _callee116$(_context116) {
                              while (1) switch (_context116.prev = _context116.next) {
                                case 0:
                                  _context116.next = 2;
                                  return updateEditor(p);
                                case 2:
                                case "end":
                                  return _context116.stop();
                              }
                            }, _callee116);
                          }));
                          function onBlur(_x118) {
                            return _onBlur96.apply(this, arguments);
                          }
                          return onBlur;
                        }()
                      },
                      height: {
                        schemaType: "Number",
                        onBlur: function () {
                          var _onBlur97 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee117(p) {
                            return (0, _regeneratorRuntime2["default"])().wrap(function _callee117$(_context117) {
                              while (1) switch (_context117.prev = _context117.next) {
                                case 0:
                                  _context117.next = 2;
                                  return updateEditor(p);
                                case 2:
                                case "end":
                                  return _context117.stop();
                              }
                            }, _callee117);
                          }));
                          function onBlur(_x119) {
                            return _onBlur97.apply(this, arguments);
                          }
                          return onBlur;
                        }()
                      },
                      key: {
                        schemaType: "String",
                        onBlur: function () {
                          var _onBlur98 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee118(p) {
                            return (0, _regeneratorRuntime2["default"])().wrap(function _callee118$(_context118) {
                              while (1) switch (_context118.prev = _context118.next) {
                                case 0:
                                  _context118.next = 2;
                                  return updateEditor(p);
                                case 2:
                                case "end":
                                  return _context118.stop();
                              }
                            }, _callee118);
                          }));
                          function onBlur(_x120) {
                            return _onBlur98.apply(this, arguments);
                          }
                          return onBlur;
                        }()
                      },
                      name: {
                        schemaType: "String",
                        onBlur: function () {
                          var _onBlur99 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee119(p) {
                            return (0, _regeneratorRuntime2["default"])().wrap(function _callee119$(_context119) {
                              while (1) switch (_context119.prev = _context119.next) {
                                case 0:
                                  _context119.next = 2;
                                  return updateEditor(p);
                                case 2:
                                case "end":
                                  return _context119.stop();
                              }
                            }, _callee119);
                          }));
                          function onBlur(_x121) {
                            return _onBlur99.apply(this, arguments);
                          }
                          return onBlur;
                        }()
                      }
                    }
                  }
                }
              }
            },
            editLines: {
              schemaType: "Object",
              properties: {
                show: {
                  schemaType: "Boolean",
                  onBlur: function () {
                    var _onBlur100 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee120(p) {
                      return (0, _regeneratorRuntime2["default"])().wrap(function _callee120$(_context120) {
                        while (1) switch (_context120.prev = _context120.next) {
                          case 0:
                            _context120.next = 2;
                            return updateEditor(p);
                          case 2:
                          case "end":
                            return _context120.stop();
                        }
                      }, _callee120);
                    }));
                    function onBlur(_x122) {
                      return _onBlur100.apply(this, arguments);
                    }
                    return onBlur;
                  }()
                },
                disableChangeEditLines: {
                  schemaType: "Boolean",
                  onBlur: function () {
                    var _onBlur101 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee121(p) {
                      return (0, _regeneratorRuntime2["default"])().wrap(function _callee121$(_context121) {
                        while (1) switch (_context121.prev = _context121.next) {
                          case 0:
                            _context121.next = 2;
                            return updateEditor(p);
                          case 2:
                          case "end":
                            return _context121.stop();
                        }
                      }, _callee121);
                    }));
                    function onBlur(_x123) {
                      return _onBlur101.apply(this, arguments);
                    }
                    return onBlur;
                  }()
                }
              }
            },
            calloutNotations: {
              schemaType: "Object",
              properties: {
                show: {
                  schemaType: "Boolean",
                  onBlur: function () {
                    var _onBlur102 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee122(p) {
                      return (0, _regeneratorRuntime2["default"])().wrap(function _callee122$(_context122) {
                        while (1) switch (_context122.prev = _context122.next) {
                          case 0:
                            _context122.next = 2;
                            return updateEditor(p);
                          case 2:
                          case "end":
                            return _context122.stop();
                        }
                      }, _callee122);
                    }));
                    function onBlur(_x124) {
                      return _onBlur102.apply(this, arguments);
                    }
                    return onBlur;
                  }()
                },
                disableChangeCalloutNotations: {
                  schemaType: "Boolean",
                  onBlur: function () {
                    var _onBlur103 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee123(p) {
                      return (0, _regeneratorRuntime2["default"])().wrap(function _callee123$(_context123) {
                        while (1) switch (_context123.prev = _context123.next) {
                          case 0:
                            _context123.next = 2;
                            return updateEditor(p);
                          case 2:
                          case "end":
                            return _context123.stop();
                        }
                      }, _callee123);
                    }));
                    function onBlur(_x125) {
                      return _onBlur103.apply(this, arguments);
                    }
                    return onBlur;
                  }()
                }
              }
            },
            postFilters: getPostFilters(),
            groups: {
              schemaType: "Object",
              properties: {
                enable: {
                  schemaType: "Boolean",
                  onBlur: function () {
                    var _onBlur104 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee124(p) {
                      return (0, _regeneratorRuntime2["default"])().wrap(function _callee124$(_context124) {
                        while (1) switch (_context124.prev = _context124.next) {
                          case 0:
                            _context124.next = 2;
                            return updateEditor(p);
                          case 2:
                          case "end":
                            return _context124.stop();
                        }
                      }, _callee124);
                    }));
                    function onBlur(_x126) {
                      return _onBlur104.apply(this, arguments);
                    }
                    return onBlur;
                  }()
                }
              }
            },
            splitScreen: {
              schemaType: "Object",
              properties: {
                startWithSplitScreen: {
                  schemaType: "Boolean",
                  onBlur: function () {
                    var _onBlur105 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee125(p) {
                      return (0, _regeneratorRuntime2["default"])().wrap(function _callee125$(_context125) {
                        while (1) switch (_context125.prev = _context125.next) {
                          case 0:
                            _context125.next = 2;
                            return updateEditor(p);
                          case 2:
                          case "end":
                            return _context125.stop();
                        }
                      }, _callee125);
                    }));
                    function onBlur(_x127) {
                      return _onBlur105.apply(this, arguments);
                    }
                    return onBlur;
                  }()
                },
                disableChangeSplitScreen: {
                  schemaType: "Boolean",
                  onBlur: function () {
                    var _onBlur106 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee126(p) {
                      return (0, _regeneratorRuntime2["default"])().wrap(function _callee126$(_context126) {
                        while (1) switch (_context126.prev = _context126.next) {
                          case 0:
                            _context126.next = 2;
                            return updateEditor(p);
                          case 2:
                          case "end":
                            return _context126.stop();
                        }
                      }, _callee126);
                    }));
                    function onBlur(_x128) {
                      return _onBlur106.apply(this, arguments);
                    }
                    return onBlur;
                  }()
                },
                hideBorders: {
                  schemaType: "Boolean",
                  onBlur: function () {
                    var _onBlur107 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee127(p) {
                      return (0, _regeneratorRuntime2["default"])().wrap(function _callee127$(_context127) {
                        while (1) switch (_context127.prev = _context127.next) {
                          case 0:
                            _context127.next = 2;
                            return updateEditor(p);
                          case 2:
                          case "end":
                            return _context127.stop();
                        }
                      }, _callee127);
                    }));
                    function onBlur(_x129) {
                      return _onBlur107.apply(this, arguments);
                    }
                    return onBlur;
                  }()
                },
                renderersData: {
                  "0": getRendererDataForSplitScreen(),
                  "2": getRendererDataForSplitScreen(),
                  "3": getRendererDataForSplitScreen(),
                  "4": getRendererDataForSplitScreen()
                }
              }
            }
          }
        }
      }
    }
  }));
}